import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import noop from 'lodash/noop';
import values from 'lodash/values';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Button from 'yoda-core-components/lib/components/Button/Button';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

import * as styles from './MessagePopup.css';
import { messageTypes } from '../Messages.config';

const cx = classNames.bind(styles);

export default class MessagePopup extends PureComponent {
    static propTypes = {
        type: PropTypes.oneOf(values(messageTypes)),
        title: PropTypes.string,
        children: PropTypes.element,
        onClose: PropTypes.func,
        className: PropTypes.string,
    };

    static defaultProps = {
        type: messageTypes.information,
        title: '',
        children: null,
        onClose: noop,
        className: '',
    };

    render() {
        const { type, title, children, className, iconComponent } = this.props;
        return (
            <div className={`${cx('message-popup', type, className)} ${dt(['text-center'])}`}>
                <ModalBox
                    showModal
                    onClose={this.props.onClose}
                    defaultHeader
                    automationId="message-dialog"
                    modalTheme={`${cx('messageModalTheme')} ${dt([
                        'pt-3',
                        'px-3',
                        'pb-8',
                        'sm:w-[270px]',
                        'md:w-[470px]',
                        'lg:w-[644px]',
                    ])}`}
                    modalContentTheme={`${cx('messageModalContentTheme`')} ${dt([
                        'text-center',
                        'smOnly:mt-0',
                    ])}`}
                    modalOverlayTheme={`${cx('messageModalOverlayTheme')} ${dt(['z-[101]'])}`}
                >
                    <div className={`${cx('message-content`')} ${dt(['mb-16'])}`}>
                        <div>
                            <Icon
                                iconType="svg"
                                automationId="apply-coupon-dialog-icon"
                                width="96px"
                                height="96px"
                                viewBox="0 0 96 96"
                            >
                                {iconComponent}
                            </Icon>
                        </div>
                        <div
                            className={`${cx('message-title')} ${dt([
                                'mb-6',
                                'text-black',
                                'font-open-sans-bold',
                                'text-2xLg',
                            ])}`}
                        >
                            {title}
                        </div>
                        <div
                            className={`${cx('message-body')} ${dt([
                                'text-gray-70',
                                'text-medium',
                                'my-6',
                            ])}`}
                        >
                            {children}
                            <Button
                                type="button"
                                buttonType="Primary"
                                size="Lg"
                                onClick={this.props.onClose}
                                className={dt(['my-0', 'mx-auto', 'max-h-12', 'w-60'])}
                            >
                                OK
                            </Button>
                        </div>
                    </div>
                </ModalBox>
            </div>
        );
    }
}
